/**
 * Follows API client (Wave E).
 *
 * The backend authoritative endpoints live under /api/follows/*.
 * /utils/follows.js is the local cache + sync façade that uses these.
 */
import { api } from '@/lib/api';

export const followsApi = {
  follow(username) {
    return api.post(`/follows/${encodeURIComponent(username)}`, {});
  },
  unfollow(username) {
    return api.delete(`/follows/${encodeURIComponent(username)}`);
  },
  toggle(username) {
    return api.post(`/follows/${encodeURIComponent(username)}/toggle`, {});
  },
  isFollowing(username) {
    return api.get(`/follows/is-following/${encodeURIComponent(username)}`);
  },
  followers(username, { limit = 100, offset = 0 } = {}) {
    return api.get(`/follows/${encodeURIComponent(username)}/followers?limit=${limit}&offset=${offset}`);
  },
  following(username, { limit = 100, offset = 0 } = {}) {
    return api.get(`/follows/${encodeURIComponent(username)}/following?limit=${limit}&offset=${offset}`);
  },
  stats(username) {
    return api.get(`/follows/${encodeURIComponent(username)}/stats`);
  },
  myFollowing({ limit = 200 } = {}) {
    return api.get(`/follows/me/following?limit=${limit}`);
  },
  // Arreglo 4C (oct-2026) — campana: seguidores a los que no sigues + sugerencias (solo info pública).
  notFollowingBack(limit = 10) { return api.get(`/follows/me/not-following-back?limit=${limit}`); },
  suggestions(limit = 10) { return api.get(`/follows/me/suggestions?limit=${limit}`); },
  dismiss(kind, targetId) { return api.post(`/follows/me/dismiss/${kind}/${encodeURIComponent(targetId)}`, {}); },
};

export default followsApi;
